import { useTranslation } from 'react-i18next'

/**
 * Annonce qu'une recherche ou un filtre ne laisse plus rien (RGAA 7.5) : le
 * message « aucun résultat » de la liste apparaît déjà rempli, et une région
 * insérée pleine n'est pas lue. Muet sans filtre, pour ne pas parler au
 * chargement.
 *
 * Le nombre de résultats, lui, est annoncé par le pied paginé
 * (`TablePagination`) dès qu'il y a au moins une ligne (#198) : l'annoncer ici
 * aussi le faisait lire deux fois à chaque frappe.
 */
function ResultsStatus({ count, filtering }: { count: number, filtering: boolean }) {
  const { t } = useTranslation()
  return <p role="status" className="sr-only">{filtering && count === 0 ? t('common.noResults') : ''}</p>
}

export default ResultsStatus
